import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import {
  Alert,
  Grid,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Page,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { User } from '../../../models/User';

import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

import { MollieLink } from '../../../models/MollieLink';
import ContentCopy from '@mui/icons-material/ContentCopy';
import { CoachMollieLinkCreate } from '../../../components/v2/dialogs/CoachMollieLinkCreate';

const { DateTime } = require("luxon");

type Props = {}

export const CoachUserPayments: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const params = useParams();
  const {t, i18n} = useTranslation(['translations']);

  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [search, setSearch] = useState<string>("");
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [createOpen, setCreateOpen] = useState<boolean>(false);

  // let is_elearning = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'elearning'});
  let is_payments = true;

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["user", 'short', (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: objectId,
          fields: [
            'id', 'first_name', 'last_name', 'consent_status'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "mollie_links", objectId, {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<MollieLink>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'mollie_link',
          fields: ['id', 'description', 'amount', 'paid', 'extra_data', 'enabled', 'linked_item', 'linked_item_type'],
          sub_fields: {
            linked_item: ['id', 'user'],
            user: ['id', 'full_name']
          },
          order: order,
          per_page: 200,
          page: page,
          filter: {
            search: search,
            advanced: {
              for_client: objectId,
              practice_id: (login?.practice_id || currentPractice?.id),
            }
          },
          for_client: objectId,
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0 && !!is_payments,
  });






  // const mutationCustomAction = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<{custom_result: {success?: boolean;}}>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     objectsRefetch();
  //   },
  // });









  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'description', headerName: t("coach.models.mollie_links.description"), width: 450 },
    { field: 'amount', headerName: t("coach.models.mollie_links.sub_count"), width: 120, align: 'right', renderCell: params => <>
      <Typography variant="caption">{params.row.amount} EUR</Typography>
    </> },
    { field: 'expiry', headerName: t("coach.models.mollie_links.expiry"), width: 200, renderCell: params => <>
      {!!params.row.extra_data?.expiry && <Typography variant="caption">{DateTime.fromISO(params.row.extra_data?.expiry).toFormat("dd/LL/y t")}</Typography>}
    </> },
    { field: 'paid', headerName: t('coach.models.mollie_links.paid'), width: 120, sortable: false, renderCell: params => <>
      {!!params.row.paid && <Check color='primary' sx={{marginBottom: -0.75}} />}
      {!params.row.paid && <Close color='secondary' sx={{marginBottom: -0.75}} />}
    </> },
    { field: 'client', headerName: t('coach.models.mollie_links.client'), width: 200, sortable: false, renderCell: params => <>
      <Typography variant="caption">{params.row.linked_item_type}</Typography>
    </> },
  ];

  return <Page
    title={t("coach.menu.mollie_links")}
    titleCrumbs={[
      {
        title: t("coach.menu.users", "Cliënten"),
        path: "/users"
      },
      {
        title: !!object?.first_name ? [object?.first_name, object?.last_name].join(" ") : 'Cliënt',
        path: `/user/${object?.id}/detail`
      }
    ]}
  >
    {!currentPractice?.settings?.mollie_api_key && <Grid item xs={12}>
      <Alert severity='info'>
        <Typography>{t("coach.models.mollie_links.warning.no_mollie_set_up")}</Typography>
      </Alert>
    </Grid>}

    <DataGrid
      action_count={1}
      // hideCount
      actions={(params) => {
        return (<>
          {!params.row.paid && !!params.row.extra_data?.mollie?.payment_link && <IconButton title="Link" color="default" onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(params.row.extra_data?.mollie?.payment_link);
          }}>
            <ContentCopy />
          </IconButton>}
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />

    <Fab
      onClick={() => {
        setCreateOpen(true);
      }}
    />

    <CoachMollieLinkCreate
      open={createOpen}
      setOpen={setCreateOpen}
      linkedUser={!!objectId ? parseInt(objectId, 10) : undefined}
      onClose={() => {

      }}
      refetch={objectsRefetch}
    />
  </Page>;
}
